<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Indice</p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_toc_1">Sinossi</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_toc_1">Anteprima</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_toc_1">Prologo</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#auto_bookmark_toc_1">Capitolo Uno</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006#auto_bookmark_toc_1">Capitolo Due</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0007#auto_bookmark_toc_1">Capitolo Tre</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0008#auto_bookmark_toc_1">Capitolo Quattro</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0009#auto_bookmark_toc_1">Capitolo Cinque</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0010#auto_bookmark_toc_1">Capitolo Sei</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0011#auto_bookmark_toc_1">Capitolo Sette</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0012#auto_bookmark_toc_1">Capitolo Otto</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0013#auto_bookmark_toc_1">Capitolo Nove</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0014#auto_bookmark_toc_1">Capitolo Dieci</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0015#auto_bookmark_toc_1">Capitolo Undici</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0016#auto_bookmark_toc_1">Capitolo Dodici</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0017#auto_bookmark_toc_1">Capitolo Tredici</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0018#auto_bookmark_toc_1">Capitolo Quattordici</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0019#auto_bookmark_toc_1">Capitolo Quindici</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0020#auto_bookmark_toc_1">Capitolo Sedici</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0021#auto_bookmark_toc_1">Capitolo Diciassette</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0022#auto_bookmark_toc_1">Capitolo Diciotto</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0023#auto_bookmark_toc_1">Biografia</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0024">Visitate il sito di Dreamspinner Press</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0025#auto_bookmark_toc_2">Copyright</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?35d1b97e